import { Color, Icon, Link, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { Trans } from 'react-i18next'

import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import * as Styled from './styles'

const translationKey = {
  isVoided: 'ledger.voided_by',
  isVoid: 'ledger.voids',
} as const

export const VoidedSection = () => {
  const { isVoidedEntry, navigateToTransaction, pairTransaction, transaction } = useTransactionDrawerContext()

  const handleLinkClick = useCallback(() => {
    if (pairTransaction) {
      navigateToTransaction(pairTransaction)
    }
  }, [navigateToTransaction, pairTransaction])

  if (!isVoidedEntry || !pairTransaction) {
    return null
  }

  const pairTransactionNo = pairTransaction.transactionNo ?? null
  const voidState = transaction?.isVoided ? 'isVoided' : 'isVoid'

  return (
    <Styled.VoidedSectionContainer>
      <Icon icon="info" color={Color.White} />
      <Text color={Color.White}>
        <Trans
          components={{ pairLink: <Link color={Color.White} onClick={handleLinkClick} /> }}
          i18nKey={translationKey[voidState]}
          values={{ number: pairTransactionNo }}
        />
      </Text>
    </Styled.VoidedSectionContainer>
  )
}
